export enum StoryType {
  Image = 'image',
  Video = 'video',
}

export interface IStoryData {
  id: string;
  image: string;
  username: string;
  stories: {
    type: StoryType;
    src: string;
    watched: boolean;
    url?: string;
  }[];
}
